module.exports = "<p class=\"small\" *ngIf=\"lastUpdate\"><strong>Last update</strong>: {{ lastUpdate| slice:0:10 }}</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/ui/content-update-info/content-update-info.component.html
// module id = ./src/app/components/ui/content-update-info/content-update-info.component.html
// module chunks = main